<template>
    <div class="">
        <div class="">
            <div class="bg-white p-3 push header-menu-content-container">
                <div class="d-lg-none">
                    <button
                        type="button"
                        class="navbar-toggler btn btn-block btn-light d-flex justify-content-between align-items-center"
                        data-toggle="collapse"
                        data-target="#horizontal-navigation-hover-normal"
                        data-class="d-none"
                    >
                        Search Filters
                        <i class="fa fa-bars"></i>
                    </button>
                </div>
                <div
                    id="horizontal-navigation-hover-normal"
                    class="collapse navbar-collapse d-lg-block mt-2 mt-lg-0"
                >
					<v-form v-model="isValid" ref="filtersForm">

					<v-container fluid>
                        <v-row>
                            <template v-for="(filter, fIdx) in compFilters">
                                <v-col
                                    v-if="
                                        filter.key == 'report' &&
                                            displayFilters.report.data
                                    "
                                    cols="12"
                                    lg="3"
                                    :key="fIdx"
                                    class="mr-3"
                                >
                                    <div class="item-filter">
                                        <v-select
                                            v-model="filters.report"
                                            :items="displayFilters.report.data"
                                            :menu-props="{ maxHeight: '400' }"
                                            :label="filter.name || 'Report'"
                                            id="report"
                                            item-text="name"
                                            return-object
                                            @change="reportChanged()"
                                        ></v-select>
                                    </div>
                                </v-col>

                                <v-col
                                    v-if="filter.key == 'dateRangeType'"
                                    cols="12"
                                    lg="2"
                                    :key="fIdx"
                                    class="mr-3"
                                >
                                    <div class="item-filter d-flex align-center">
                                      <v-select
                                          v-model="filters.dateRangeType"
                                          :items="displayFilters.dateRangeType.data"
                                          :menu-props="{ maxHeight: '400' }"
                                          :label="filter.name || 'Date Range Type'"
                                          id="dateRangeTypeMain"
                                          item-value="id"
                                          item-text="name"
                                      ></v-select>
                                    </div>
                                </v-col>
                                <v-col
                                    v-if="filter.key == 'dateRange'"
                                    cols="12"
                                    lg="3"
                                    :key="fIdx"
                                    class="mr-3"
                                >
                                    <div
                                        class="item-filter d-flex align-center"
                                    >
                                        <v-menu
                                            ref="computedDateRange2"
                                            v-model="picker1"
                                            :close-on-content-click="false"
                                            :nudge-right="$vuetify.breakpoint.smAndDown ? 0 : 40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-text-field
                                                    v-model="filters.dateRange"
                                                    :label="
                                                        filter.name ||
                                                            'Select Date'
                                                    "
                                                    prepend-icon="mdi-calendar"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    readonly
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="computedDateRange2"
                                                range
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    class="font-weight-bold"
                                                    @click="picker1 = false"
                                                >
                                                    Close
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                        <!-- <v-text-field
                      ref="computedDateRange2"
                      v-model="filters.dateRange"
                      :label="filter.name || 'Select Date'"
                      @blur="textDateHandler(filters.dateRange)"
                    >
                    </v-text-field> -->
                                    </div>
                                </v-col>
                                <v-col
                                    v-if="filter.key == 'date'"
                                    cols="12"
                                    lg="3"
                                    :key="fIdx"
                                    class="mr-3"
                                >
                                    <div
                                        class="item-filter d-flex align-center"
                                    >
                                        <v-menu
                                            ref="computedDate"
                                            v-model="pickerDate"
                                            :close-on-content-click="false"
                                            :nudge-right="$vuetify.breakpoint.smAndDown ? 0 : 40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-text-field
                                                    v-model="computedDisplayDate"
                                                    :label="
                                                        filter.name ||
                                                            'Select Date'
                                                    "
                                                    prepend-icon="mdi-calendar"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    readonly
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="computedDate"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    class="font-weight-bold"
                                                    @click="pickerDate = false"
                                                >
                                                    Close
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </div>
                                </v-col>
                                <v-col
                                    v-if="filter.key == 'month'"
                                    cols="12"
                                    lg="3"
                                    :key="fIdx"
                                    class="mr-3"
                                >
                                    <div
                                        class="item-filter d-flex align-center"
                                    >
                                        <v-menu
                                            ref="computedMonth"
                                            v-model="pickerMonth"
                                            :close-on-content-click="false"
                                            :nudge-right="$vuetify.breakpoint.smAndDown ? 0 : 40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-text-field
                                                    v-model="computedDisplayMonth"
                                                    :label="
                                                        filter.name ||
                                                            'Select Month'
                                                    "
                                                    prepend-icon="mdi-calendar"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    readonly
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="computedMonth"
                                                type="month"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    class="font-weight-bold"
                                                    @click="pickerMonth = false"
                                                >
                                                    Close
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </div>
                                </v-col>
                            </template>
                        </v-row>
                        <v-row>
                            <ul
                                class="w-100 nav-main nav-main-horizontal nav-main-hover"
                                style="padding-left:5px;"
                            >
                                <li class="nav-main-item mb-1 mb-1" v-if="columnOptions">
                                    <a
                                        data-toggle="submenu"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        href="#"
                                        class="nav-main-link nav-main-link-submenu"
                                    >
                                        <i
                                            class="nav-main-link-icon fa fa-columns"
                                        ></i>
                                        <span class="nav-main-link-name"
                                            >Columns</span
                                        >
                                    </a>
                                    <ul class="nav-main-submenu p-0">
                                        <li class="nav-main-item mb-1">
                                            <div class="col-lg-12">
                                                <span
                                                    v-for="(columnOption,
                                                    key) in columnOptions"
                                                    :key="key"
                                                >
                                                    <input
                                                        autocomplete="off"
                                                        type="checkbox"
                                                        class="filter-columns form-control-alt"
                                                        :value="key"
                                                        :checked="
                                                            !columnOption.unchecked
                                                        "
                                                        @click="columnChecked()"
                                                    />{{ columnOption.name }}
                                                    <br />
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                </li>

                                <li
                                    class="nav-main-item mb-1"
                                    v-for="(filter, fIdx) in compFilters"
                                    :key="fIdx"
                                >
                                    <span
                                        class="mr-3"
                                        v-if="filter.key == 'campaigns'"
                                    >
                                        <span v-if="filter.multiselect">
                                            <v-select
                                                v-model="filters.campaignIds"
                                                :items="
                                                    displayFilters.campaigns
                                                        .data
                                                "
                                                :menu-props="{
                                                    maxHeight: '400'
                                                }"
                                                :label="
                                                    filter.name || 'Campaigns'
                                                "
                                                id="campaignIdsMain"
                                                item-value="id"
                                                item-text="name"
                                                :clearable="true"
                                                multiple
                                            ></v-select>
                                        </span>
                                        <span v-else>
                                            <select
                                                id="invitedToCampaignId"
                                                class="form-control"
                                                v-model="
                                                    filters.invitedToCampaignId
                                                "
                                                @change="applyData()"
                                            >
                                                <option :value="null"
                                                    >- All Campaigns -</option
                                                >
                                                <option
                                                    :value="campaign.id"
                                                    v-for="(campaign,
                                                    cIdx) in filter.data"
                                                    :key="cIdx"
                                                    >{{ campaign.name }}</option
                                                >
                                            </select>
                                        </span>
                                    </span>
                                    <span
                                        class="mr-3"
                                        v-if="filter.key == 'fields'"
                                    >
                                        <div class="item-filter">
                                            <v-select
                                                v-model="filters.fieldIds"
                                                :items="
                                                    displayFilters.fields.data
                                                "
                                                :menu-props="{
                                                    maxHeight: '400'
                                                }"
                                                :label="filter.name || 'Fields'"
                                                id="fieldIdsMain"
                                                item-value="id"
                                                item-text="name"
                                                :clearable="true"
                                                multiple
                                            ></v-select>
                                        </div>
                                    </span>
									<span
										class="mr-3"
										v-if="filter.key == 'polls'"
									>
                                        <div class="item-filter"  style="display:flex">
                                            <v-select
												v-model="filters.pollId"
												:items="
                                                    displayFilters.polls.data
                                                "
												:menu-props="{
                                                    maxHeight: '400'
                                                }"
												:label="filter.name || 'Poll'"
												id="pollIdMain"
												item-value="id"
												item-text="name"
												:clearable="true"
												:rules="[v => !displayFilters.polls.required || !!v || 'Please select a '+(filter.name || 'Poll')]"
											></v-select>
											<span class="red--text" v-if="displayFilters.polls.required" >*</span>
                                        </div>
                                    </span>
                                    <span
                                        class="mr-3"
                                        v-if="filter.key == 'partner'"
                                    >
										<div class="item-filter" style="display:flex">
                                            <v-select
                                                v-model="filters.partnerId"
                                                :items="
                                                    displayFilters.partner.data
                                                "
                                                :menu-props="{
                                                    maxHeight: '400'
                                                }"
                                                :label="
                                                    filter.name || 'Partner'
                                                "
                                                id="partnerIdMain"
                                                item-text="name"
                                                item-value="id"
                                                :clearable="true"
												:rules="[v => !displayFilters.partner.required || !!v || 'Please select a '+(filter.name || 'Partner')]"
                                            ></v-select>
											<span class="red--text" v-if="displayFilters.partner.required" >*</span>
                                        </div>
											 
                                    </span>
									<span
										class="mr-3"
										v-if="filter.key == 'partners'"
									>
                                        <div class="item-filter" style="display:flex">
                                            <v-select
												v-model="filters.partnerIds"
												:items="displayFilters.partners.data"
												:menu-props="{
                                                    maxHeight: '400'
                                                }"
												:label="
                                                    filter.name || 'Partners'
                                                "
												id="partnerIdMain"
												item-text="name"
												item-value="id"
												:clearable="true"
												:multiple="true"
											></v-select>
											<span class="red--text" v-if="displayFilters.partners.required" >*</span>
                                        </div>
                                    </span>
                                    <!-- TODO: Offers "clear" button refreshes the page, though it doesn't refresh the data. The refresh should be shut off -->
                                    <span
                                        class="mr-3"
                                        v-if="filter.key == 'offers'"
                                    >
                                        <div class="item-filter">
                                            <v-select
                                                v-model="filters.offerIds"
                                                :items="
                                                    displayFilters.offers.data
                                                "
                                                :menu-props="{
                                                    maxHeight: '400'
                                                }"
                                                :label="filter.name || 'Offers'"
                                                id="offerIdsMain"
                                                item-value="id"
                                                item-text="name"
                                                :clearable="true"
                                                :multiple="typeof displayFilters.offers.multiple != 'undefined' ? displayFilters.offers.multiple : true"
												@blur="$emit('filter-blur', filters)"
                                            ></v-select>
                                        </div>
                                    </span>
                                    <span
                                        class="mr-3"
                                        v-if="filter.key == 'deals'"
                                    >
                                        <div class="item-filter">
                                            <v-select
                                                v-model="filters.dealIds"
                                                :items="
                                                    displayFilters.deals.data
                                                "
                                                :menu-props="{
                                                    maxHeight: '400'
                                                }"
                                                :label="filter.name || 'Deals'"
                                                id="dealIdsMain"
                                                item-value="id"
                                                item-text="name"
                                                :clearable="true"
                                                multiple
                                            ></v-select>
                                        </div>
                                    </span>
                                    <span
                                        class="mr-3"
                                        v-if="filter.key == 'messageLists'"
                                    >
                                        <div class="item-filter">
                                            <v-select
                                                v-model="filters.messageListIds"
                                                :items="
                                                    displayFilters.messageLists
                                                        .data
                                                "
                                                :menu-props="{
                                                    maxHeight: '400'
                                                }"
                                                :label="
                                                    filter.name ||
                                                        'Message Lists'
                                                "
                                                id="messageListIdsMain"
                                                item-value="id"
                                                item-text="name"
                                                :clearable="true"
                                                multiple
                                            ></v-select>
                                        </div>
                                    </span>
                                    <span
                                        class="mr-3"
                                        v-if="filter.key == 'users'"
                                    >
										
                                        <div class="item-filter" style="display:flex">
                                            <v-select
                                                v-model="filters.userIds"	
                                                :items="
                                                    displayFilters.users.data
                                                "
                                                :menu-props="{
                                                    maxHeight: '400'
                                                }"
                                                :label="filter.name || 'Users'"
                                                id="userIdsMain"
                                                item-value="id"
                                                item-text="name"
                                                :clearable="true"
                                                :multiple="filter.multiselect === undefined ? true : filter.multiselect"
												:rules="[v => !displayFilters.users.required || !!v || displayFilters.users.validationMessage || 'Please select '+(filter.name || 'Users')]"
                                            ></v-select>
											<span class="red--text" v-if="displayFilters.users.required" >*</span>
                                        </div>
                                    </span>
                                    <span class="mr-3" v-if="filter.key == 'resellers'">
                                        <div class="item-filter">
                                        <v-select
                                            v-model="filters.resellerIds"
                                            :items="displayFilters.resellers.data"
                                            :menu-props="{ maxHeight: '400' }"
                                            :label="filter.name || 'Resellers'"
                                            id="resellerIdsMain"
                                            item-value="id"
                                            item-text="name"
                                            :clearable="true"
                                            multiple
                                            v-show="showResellerOnSalesChannel"
                                        ></v-select>
                                        </div>
                                    </span>
                                    <span
                                        class="mr-3"
                                        v-if="filter.key == 'affiliates'"
                                    >
                                        <div class="item-filter">
                                            <v-select
                                                v-model="filters.affiliateIds"
                                                :items="
                                                    displayFilters.affiliates
                                                        .data
                                                "
                                                :menu-props="{
                                                    maxHeight: '400'
                                                }"
                                                :label="
                                                    filter.name || 'Affiliates'
                                                "
                                                id="affiliateIdsMain"
                                                item-value="id"
                                                item-text="name"
                                                :clearable="true"
                                                multiple
                                            ></v-select>
                                        </div>
                                    </span>
									<span
										class="mr-3"
										v-if="filter.key == 'outcomes'"
									>
                                        <div class="item-filter">
                                            <v-select
												v-model="filters.outcomeIds"
												:items="
                                                    displayFilters.outcomes
                                                        .data
                                                "
												:menu-props="{
                                                    maxHeight: '400'
                                                }"
												:label="
                                                    filter.name || 'Outcomes'
                                                "
												id="outcomeIdsMain"
												item-value="id"
												item-text="name"
												:clearable="true"
												multiple
											></v-select>
                                        </div>
                                    </span>
									<span
										class="mr-3"
										v-if="filter.key == 'durations'"
									>
                                        <div class="item-filter">
                                            <v-select
												v-model="filters.durationId"
												:items="
                                                    displayFilters.durations
                                                        .data
                                                "
												:menu-props="{
                                                    maxHeight: '400'
                                                }"
												:label="
                                                    filter.name || 'Duration'
                                                "
												id="durationIdMain"
												item-value="id"
												item-text="value"
												:clearable="true"
											></v-select>
                                        </div>
                                    </span>
                                    <span class="mr-3" v-if="filter.key == 'salesChannels'">
                                      <div class="item-filter">
                                        <v-select
                                            v-model="filters.salesChannel"
                                            :items="salesChannelsData()"
                                            :menu-props="{ maxHeight: '400' }"
                                            :label="filter.name || 'Sales Channel'"
                                            id="salesChannelMain"
                                            item-value="id"
                                            item-text="name"
                                            :clearable="true"
                                            v-on:change="salesChannelsChanged()"
                                        ></v-select>
                                      </div>
                                    </span>
                                    <span class="mr-3" v-if="filter.key == 'promos'">
                                      <div class="item-filter">
                                        <v-select
                                            v-model="filters.promoIds"
                                            :items="displayFilters.promos.data"
                                            :menu-props="{ maxHeight: '400' }"
                                            :label="filter.name || 'Promos'"
                                            id="promoIdsMain"
                                            item-value="id"
                                            item-text="name"
                                            :clearable="true"
                                            multiple
                                            v-show="showPromoOnSalesChannel"
											@blur="$emit('filter-blur', filters)"
                                        ></v-select>
                                      </div>
                                    </span>
									<span class="mr-3" v-if="filter.key == 'promoCodes'">
                                      <div class="item-filter">
                                        <v-select
											v-model="filters.promoCodeIds"
											:items="displayFilters.promoCodes.data"
											:menu-props="{ maxHeight: '400' }"
											:label="filter.name || 'Promo Codes'"
											id="promoCodeIdsMain"
											item-value="id"
											item-text="code"
											group-by="group"
											:clearable="true"
											multiple
											v-show="showPromoOnSalesChannel"
										></v-select>
                                      </div>
                                    </span>
                                    <span class="mr-3" v-if="filter.key == 'fulfillers'">
                                      <div class="item-filter">
                                        <v-select
                                            v-model="filters.fulfillerId"
                                            :items="displayFilters.fulfillers.data"
                                            :menu-props="{ maxHeight: '400' }"
                                            :label="filter.name || 'Fulfillers'"
                                            id="fulfillersMain"
                                            item-value="id"
                                            item-text="name"
                                            :clearable="true"
                                            ></v-select>
                                      </div>
                                    </span>
                                  <span class="mr-3" v-if="filter.key == 'regions'">
                                      <div class="item-filter">
                                        <v-select
                                            v-model="filters.regionId"
                                            :items="displayFilters.regions.data"
                                            :menu-props="{ maxHeight: '400' }"
                                            :label="filter.name || 'Regions'"
                                            id="regionsMain"
                                            item-value="id"
                                            item-text="name"
                                            :clearable="true"
                                        ></v-select>
                                      </div>
                                    </span>
									<span class="mr-3" v-if="filter.key == 'processingAccount'">
                                      <div class="item-filter">
                                        <v-select
											v-model="filters.processingAccountId"
											:items="displayFilters.processingAccount.data"
											:menu-props="{ maxHeight: '400' }"
											:label="filter.name || 'Processing Accounts'"
											id="processingAccountMain"
											item-value="id"
											item-text="name"
										></v-select>
                                      </div>
                                    </span>
									<span class="mr-3" v-if="filter.key == 'signUpSource'">
                                      <div class="item-filter">
                                        <v-select
											v-model="filters.signUpSourceId"
											:items="displayFilters.signUpSource.data"
											:menu-props="{ maxHeight: '400' }"
											:label="filter.name || 'Sign Up Source'"
											id="signUpSourceMain"
											item-value="id"
											item-text="name"
										></v-select>
                                      </div>
                                    </span>
                                    <span
                                        class="mr-3"
                                        v-if="filter.key == 'minLocations'"
                                    >
                                        <div class="item-filter">
                                            <v-text-field
                                                id="minLocations"
                                                v-model="filters.minLocations"
                                                :label="
                                                    filter.name ||
                                                        'Min Locations'
                                                "
                                            >
                                            </v-text-field>
                                        </div>
                                    </span>
                                    <span
                                        class="mr-3"
                                        v-if="filter.key == 'includeFreeAttributes'"
                                    >
                                        <v-checkbox
                                            type="checkbox"
                                            v-model="filters.includeFreeAttributes"
                                            :label="filter.name ||
                                                  'Include Free Attributes'"
                                        >
                                        </v-checkbox>
                                    </span>
                                    <span
                                        class="mr-3"
                                        v-if="filter.key == 'inactive'"
                                    >
                                        <v-checkbox
                                            type="checkbox"
                                            v-model="filters.inactive"
                                            :label="filter.name ||
                                                  'Show inactive campaigns'"
                                        >
                                        </v-checkbox>
                                    </span>
                                    <span
                                        class="mr-3"
                                        v-if="filter.key == 'minPoints'"
                                    >
                                        <div class="item-filter">
                                            <v-text-field
                                                id="minPoints"
                                                v-model="filters.minPoints"
                                                :label="
                                                    filter.name ||
                                                        'Min Points'
                                                "
                                            >
                                            </v-text-field>
                                        </div>
                                    </span>
																	<span class="mr-3" v-if="filter.key == 'identifierType'">
                                      <div class="item-filter">
                                        <v-select
																						v-model="filters.identifierType"
																						:items="displayFilters.identifierType.data"
																						:menu-props="{ maxHeight: '400' }"
																						:label="filter.name || 'ID Type'"
																						id="identifierTypeMain"
																						item-value="id"
																						item-text="name"
																				></v-select>
                                      </div>
                                    </span>
																		<span
																				class="mr-3"
																				v-if="filter.key == 'identifier'"
																		>
																			<div class="item-filter">
																				<v-text-field
																					id="identifier"
																					v-model="filters.identifier"
																					:label="
																						filter.name ||
																						'ID'
																					"
																				>
																				</v-text-field>
																			</div>
																		</span>
																	<span
                                        class="mr-3"
                                        v-if="filter.key == 'hideDoNotCharge'"
                                    >
                                      <div class="item-filter">
                                        <v-checkbox
                                            type="checkbox"
                                            v-model="filters.hideDoNotCharge"
                                            :label="filter.name ||
                                                  'Hide Do Not Charge'"
                                        >
                                        </v-checkbox>
                                      </div>
                                  </span>
                                  <span v-if="filter.key == 'venues'">
                                        <div class="item-filter">
                                            <span v-if="filter.multiselect">
                                                <v-select
                                                    v-model="filters.venueIds"
                                                    :items="
                                                        displayFilters.venues
                                                            .data
                                                    "
                                                    :menu-props="{
                                                        maxHeight: '400'
                                                    }"
                                                    :label="
                                                        filter.name || 'Venues'
                                                    "
                                                    id="venueIdsMain"
                                                    item-value="id"
                                                    item-text="name"
                                                    :clearable="true"
                                                    multiple
                                                ></v-select>
                                            </span>
                                            <span v-else>
                                                <select
                                                    id="venueIdMain"
                                                    class="form-control"
                                                    v-model="filters.venueId"
                                                    @change="applyData(true)"
                                                >
                                                    <option :value="null"
                                                        >- All Venues -</option
                                                    >
                                                    <option
                                                        :value="venue.id"
                                                        v-for="(venue,
                                                        vIdx) in filter.data"
                                                        :key="vIdx"
                                                        >{{
                                                            venue.name
                                                        }}</option
                                                    >
                                                </select>
                                            </span>
                                        </div>
                                    </span>
                                    <span v-if="filter.key == 'templates'">
                                        <div class="item-filter">
                                            <span >
                                                <select
                                                    id="templateIdMain"
                                                    class="form-control"
                                                    v-model="filters.templateId"
                                                    @change="applyData(true)"
                                                >
                                                    <option :value="null"
                                                    >- All templates -</option
                                                    >
                                                    <option
                                                        :value="template.id"
                                                        v-for="(template,
                                                        vIdx) in filter.data"
                                                        :key="vIdx"
                                                    >{{
                                                            template.name
                                                        }}</option
                                                    >
                                                </select>
                                            </span>
                                            
                                        </div>
                                    </span>
                                    <span
                                        class="mr-3"
                                        v-if="filter.key == 'products'"
                                    >
                                        <div class="item-filter">
                                            <v-select
                                                v-model="filters.productIds"
                                                :items="
                                                    displayFilters.products.data
                                                "
                                                :menu-props="{
                                                    maxHeight: '400'
                                                }"
                                                :label="
                                                    filter.name || 'Products'
                                                "
                                                id="productIdsMain"
                                                item-value="id"
                                                item-text="name"
                                                :clearable="true"
                                                multiple
                                            ></v-select>
                                        </div>
                                    </span>
                                    <span
                                        class="mr-3"
                                        v-if="filter.key == 'items'"
                                    >
                                        <div class="item-filter">
                                            <v-select
                                                v-model="selected_items"
                                                :items="
                                                    printItemsVuetify(
                                                        displayFilters.items
                                                    )
                                                "
                                                :menu-props="{
                                                    maxHeight: '400'
                                                }"
                                                :label="filter.name || 'Items'"
                                                id="itemsMain"
                                                item-value="value"
                                                item-text="name"
                                                :clearable="true"
                                                multiple
                                            ></v-select>
                                        </div>
                                    </span>
                                    <span v-if="filter.key == 'statuses'">
                                        <div class="item-filter">
                                            <span v-if="filter.multiselect">
                                                <v-select
                                                    v-model="filters.statusIds"
                                                    :items="
                                                        displayFilters.statuses
                                                            .data
                                                    "
                                                    :menu-props="{
                                                        maxHeight: '400'
                                                    }"
                                                    :label="
                                                        filters.name ||
                                                            'Statuses'
                                                    "
                                                    id="statusIdsMain"
                                                    item-value="id"
                                                    item-text="name"
                                                    :clearable="true"
                                                    multiple
                                                ></v-select>
                                            </span>
                                            <!--								Old way of doing mulitselects-->
                                            <span
                                                v-else-if="
                                                    filter.type === 'multiple'
                                                "
                                            >
                                                <multiselect
                                                    class="col col-sm-12 col-md-4 col-lg-12 p-0"
                                                    id="statuses"
                                                    name="statuses"
                                                    v-model="selected_statuses"
                                                    :options="filter.data"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    track-by="id"
                                                    label="name"
                                                    :hide-selected="true"
                                                    :placeholder="
                                                        filter.name ||
                                                            'Select Status(es)'
                                                    "
                                                    @input="applyData(true)"
                                                ></multiselect>
                                            </span>
                                            <span v-else>
                                                <select
                                                    id="status"
                                                    class="form-control"
                                                    v-model="filters.status"
                                                    @change="applyData(true)"
                                                >
                                                    <option :value="null"
                                                        >- All
                                                        {{
                                                            filter.name ||
                                                                'Statuses'
                                                        }}
                                                        -</option
                                                    >
                                                    <option
                                                        :value="status.id"
                                                        v-for="(status,
                                                        sIdx) in filter.data"
                                                        :key="sIdx"
                                                        >{{
                                                            status.name
                                                        }}</option
                                                    >
                                                </select>
                                            </span>
                                        </div>
                                    </span>
                                    <!--							TODO: find a better way to have more status filters-->
                                    <span v-if="filter.key == 'statuses2'">
                                        <div class="item-filter">
                                            <span
                                                v-if="
                                                    filter.type === 'multiple'
                                                "
                                            >
                                                <multiselect
                                                    class="col col-sm-12 col-md-4 col-lg-12 p-0"
                                                    id="statuses2Main"
                                                    v-model="
                                                        selected_statuses_2
                                                    "
                                                    :options="filter.data"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    track-by="id"
                                                    label="name"
                                                    :hide-selected="true"
                                                    :placeholder="
                                                        filter.name ||
                                                            'Select Status(es)'
                                                    "
                                                    @input="applyData(true)"
                                                ></multiselect>
                                            </span>
                                            <span v-else>
                                                <select
                                                    id="status2Main"
                                                    class="form-control"
                                                    v-model="filters.status2"
                                                    @change="applyData(true)"
                                                >
                                                    <option :value="null"
                                                        >- All
                                                        {{
                                                            filter.name ||
                                                                'Statuses'
                                                        }}
                                                        -</option
                                                    >
                                                    <option
                                                        :value="status.id"
                                                        v-for="(status,
                                                        sIdx) in filter.data"
                                                        :key="sIdx"
                                                        >{{
                                                            status.name
                                                        }}</option
                                                    >
                                                </select>
                                            </span>
                                        </div>
                                    </span>
                                    <div
                                        class="form-group"
                                        v-if="displayFilters.messageStatuses"
                                    >
                                        <!-- <label>Filter Msg Status</label> -->
                                        <select
                                            class="form-control"
                                            name="selectFilterStatus"
                                            id=""
                                            v-model="filters.status"
                                            @change="applyData()"
                                        >
                                            <option :value="null"
                                                >Status</option
                                            >
                                            <option value="draft">Draft</option>
                                            <option value="sending"
                                                >Sending</option
                                            >
                                            <option value="scheduled"
                                                >Scheduled</option
                                            >
                                            <option value="sent">Sent</option>
                                        </select>
                                    </div>
                                    <span v-if="displayFilters.logLevels">
                                        <button
                                            type="button"
                                            class="btn btn-outline-info js-click-ripple-enabled"
                                            data-toggle="click-ripple"
                                            style="overflow: hidden; position: relative; z-index: 1;"
                                            v-on:click="
                                                filters.level = 'info'
                                                applyData()
                                            "
                                        >
                                            Info
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-outline-warning js-click-ripple-enabled"
                                            data-toggle="click-ripple"
                                            style="overflow: hidden; position: relative; z-index: 1;"
                                            v-on:click="
                                                filters.level = 'medium'
                                                applyData()
                                            "
                                        >
                                            Medium
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-outline-danger js-click-ripple-enabled"
                                            data-toggle="click-ripple"
                                            style="overflow: hidden; position: relative; z-index: 1;"
                                            v-on:click="
                                                filters.level = 'high'
                                                applyData()
                                            "
                                        >
                                            High
                                        </button>
                                    </span>
                                    <span v-if="displayFilters.roleKinds">
                                        <label>Role Kind</label>
                                        <select
                                            class="form-control"
                                            name="selectFilterKind"
                                            id=""
                                            v-model="filters.roleKind"
                                            @change="applyData()"
                                        >
                                            <option value="partner"
                                                >Partner</option
                                            >
                                            <option value="superAdmin"
                                                >Bandwango</option
                                            >
                                            <!-- <option value="venue">Venue</option> -->
                                        </select>
                                    </span>
                                    <span v-if="filter.key == 'categories'">
                                        <div class="item-filter">
                                            <span v-if="filter.multiselect">
                                                <v-select
                                                    v-model="
                                                        filters.categoryIds
                                                    "
                                                    :items="
                                                        displayFilters
                                                            .categories.data
                                                    "
                                                    :menu-props="{
                                                        maxHeight: '400'
                                                    }"
                                                    :label="
                                                        filter.name ||
                                                            'Categories'
                                                    "
                                                    id="categoryIdsMain"
                                                    item-value="id"
                                                    item-text="name"
                                                    :clearable="true"
                                                    multiple
                                                ></v-select>
                                            </span>
                                            <span v-else>
                                                <select
                                                    id="categoryIdMain"
                                                    class="form-control"
                                                    v-model="filters.categoryId"
                                                    @change="applyData(true)"
                                                >
                                                    <option :value="null"
                                                        >- All Categories
                                                        -</option
                                                    >
                                                    <option
                                                        :value="category.id"
                                                        v-for="(category,
                                                        cIdx) in filter.data"
                                                        :key="cIdx"
                                                        >{{
                                                            category.name
                                                        }}</option
                                                    >
                                                </select>
                                            </span>
                                        </div>
                                    </span>
                                </li>

                                <li class="nav-main-item mb-1" v-if="hasMoreFilters">
                                    <a
                                        type="button"
                                        class="nav-main-link push m-0"
                                        data-toggle="modal"
                                        data-target="#modal-block-normal"
                                    >
                                        <i
                                            class="nav-main-link-icon fa fa-filter"
                                        ></i>
                                        Filters
                                        <div
                                            class="nav-main-link-badge badge badge-pill badge-primary"
                                            v-if="filterCount"
                                        >
                                            {{ filterCount }}
                                        </div>
                                    </a>
                                </li>
                                <li class="nav-main-item mb-1" v-if="hasMoreFilters">
                                    <button
                                        v-on:click.prevent="resetData"
                                        class="btn btn-light btn-sm text-muted nav-main-link"
                                    >
                                        <i class="si si-reload fa-1x mr-1"></i
                                        ><span>Reset</span>
                                    </button>
                                </li>
                                <li class="nav-main-item mb-1">
                                    <span v-if="!!displayFilters.export">
                                          <button
                                              v-if="!exportLoading"
                                              class="btn btn-warning btn-sm nav-main-link"
                                              @click="exportData"
                                          >
                                          Export
                                        </button>
                                        <v-progress-circular
                                            indeterminate
                                            color="primary"
                                            v-else
                                        ></v-progress-circular>
                                      </span>
                                </li>
                            </ul>
                        </v-row>

                        <div>
                            <v-btn
                                v-if="showApplyButton"
                                rounded
                                elevation="0"
                                type="button"
                                :color="buttonColor"
                                dark
                                :disabled="disableButton"
                                @click.prevent="applySearch"
								>Search</v-btn>
                                <v-progress-circular v-if="showSpinnerOnApplyButton"
                                    indeterminate
                                    color="primary"
                                ></v-progress-circular>
                            <div v-if="buttonText">{{buttonText}}</div>
                        </div>
                        
                    </v-container>
					</v-form>
                    <!-- <ul class="nav-main nav-main-horizontal nav-main-hover ">
            </ul> -->
                </div>
            </div>

            <div class="input-group mt-4" v-if="displayFilters.searchOptions">
                <input
                    autocomplete="off"
                    id="filter-search"
                    type="text"
                    class="form-control mt-0"
                    v-model="filters.search"
                    v-on:keyup.enter="searchChanged()"
                    placeholder="Search..."
                />
                <!--				<span id="searchClear" class="form-control-clear fa fa-times form-control-feedback mt-1" v-if="filters.search && filters.search.length" @click="clearSearchText()"></span>-->
                <div class="input-group-append">
                    <button
                        id="searchButton"
                        type="button"
                        class="btn btn-primary dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="true"
                    >
                        {{
                            displayFilters.searchOptions.data[
                                filters.searchType
                            ]
                        }}
                    </button>
                    <div
                        id="filter-search-type"
                        class="dropdown-menu dropdown-menu-right font-size-sm"
                        aria-labelledby="dropdown-default-primary"
                        x-placement="bottom-start"
                        style="position: absolute; transform: translate3d(0px, 38px, 0px); top: 0px; left: 0px; will-change: transform;"
                    >
                        <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click.prevent="searchChanged(option, true)"
                            :data-option-value="value"
                            v-for="(option, value) in displayFilters
                                .searchOptions.data"
                            :key="value"
                            >{{ option }}</a
                        >
                    </div>
                </div>
            </div>

            <div
                v-if="hasMoreFilters"
                class="modal"
                id="modal-block-normal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-block-normal"
                aria-modal="false"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="block block-themed block-transparent mb-0">
                            <div class="block-header bg-primary-dark">
                                <h3 class="block-title">Filter Your Content</h3>
                                <div class="block-options">
                                    <button
                                        type="button"
                                        class="btn-block-option"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <i class="fa fa-fw fa-times"></i>
                                    </button>
                                </div>
                            </div>
                            <div
                                class="block-content bg-body-light pb-4"
                                v-if="displayFilters.presets"
                            >
                                <select
                                    id="filter-preset"
                                    class="form-control"
                                    v-model="filters.preset"
                                    @change="presetChanged"
                                >
                                    <option :value="null"
                                        >Select a preset...</option
                                    >
                                    <option
                                        v-for="(subReport, sIdx) in subReports"
                                        :value="subReport.id"
                                        :key="sIdx"
                                        >{{ subReport.name }}</option
                                    >
                                </select>
                            </div>
                            <div
                                class="block-content font-size-sm filter-length"
                            >
                                <div
                                    class="form-group"
                                    v-if="displayFilters.priority"
                                >
                                    <label>Priority</label>
                                    <select
                                        id="level"
                                        class="form-control form-control-alt"
                                        v-model="filters.level"
                                    >
                                        <option :value="''"
                                            >--All Levels--</option
                                        >
                                        <option
                                            value="offerStatus"
                                            v-for="(offerStatus,
                                            oIdx) of displayFilters.priority
                                                .data"
                                            :key="oIdx"
                                        >
                                            {{ offerStatus }}
                                        </option>
                                    </select>
                                </div>

                                <div
                                    class="form-group"
                                    v-if="
                                        displayFilters.dateRange &&
                                            (!displayFilters.dateRange
                                                .position ||
                                                displayFilters.dateRange
                                                    .position != 'main')
                                    "
                                >
                                    <label for="" class="w-100"
                                        >Select Date</label
                                    >
                                    <date-range-picker
                                        ref="picker"
                                        :auto-apply="true"
                                        :single-date-picker="false"
                                        :show-week-numbers="true"
                                        v-model="computedDateRange"
                                        :timePicker="true"
                                        :show-ranges="true"
                                        :append-to-body="true"
                                        :ranges="rangeOptions"
                                    >
                                    </date-range-picker>
                                </div>

                                <div
                                    class="form-group"
                                    v-if="displayFilters.offerStatuses"
                                >
                                    <label>Offer Types</label>
                                    <section
                                        class="filter-offer-button-container"
                                    >
                                        <button
                                            class="btn btn-light js-click-ripple-enabled filter-button-default"
                                            @click="
                                                filters.status = 'development'
                                                applyData()
                                            "
                                            :class="{
                                                filterButton:
                                                    filters.status ===
                                                    'development'
                                            }"
                                        >
                                            Dev
                                        </button>
                                        <button
                                            class="btn btn-light js-click-ripple-enabled filter-button-default"
                                            @click="
                                                filters.status = 'active'
                                                applyData()
                                            "
                                            :class="{
                                                filterButton:
                                                    filters.status === 'active'
                                            }"
                                        >
                                            Active
                                        </button>
                                        <button
                                            class="btn btn-light js-click-ripple-enabled filter-button-default"
                                            @click="
                                                filters.status = 'archived'
                                                applyData()
                                            "
                                            :class="{
                                                filterButton:
                                                    filters.status ===
                                                    'archived'
                                            }"
                                        >
                                            Archived
                                        </button>
                                        <button
                                            class="btn btn-light js-click-ripple-enabled filter-button-default"
                                            @click="
                                                filters.status = 'complete'
                                                applyData()
                                            "
                                            :class="{
                                                filterButton:
                                                    filters.status ===
                                                    'complete'
                                            }"
                                        >
                                            Completed
                                        </button>
                                    </section>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="displayFilters.roles"
                                >
                                    <label> Role </label>
                                    <select
                                        id="roleId"
                                        class="form-control form-control-alt"
                                        v-model="filters.roleId"
                                    >
                                        <option :value="''"
                                            >--All Roles--</option
                                        >
                                        <option
                                            :value="role.id"
                                            v-for="(role,
                                            rIdx) in displayFilters.roles.data"
                                            :key="rIdx"
                                        >
                                            {{ printRole(role) }}
                                        </option>
                                    </select>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="
                                        displayFilters.offers &&
                                            (!displayFilters.offers.position ||
                                                displayFilters.offers
                                                    .position != 'main')
                                    "
                                >
                                    <label> Offer </label>
                                    <select
                                        id="offerIds"
                                        name="offerIds"
                                        class="chosen-select filter-id-values form-control form-control-alt"
                                        multiple="multiple"
                                        v-model="filters.offerIds"
                                        data-placeholder="Select Offers"
                                    >
                                        <option
                                            :value="offer.id"
                                            v-for="(offer,
                                            oIdx) in displayFilters.offers.data"
                                            :key="oIdx"
                                        >
                                            {{ offer.name }}
                                        </option>
                                    </select>
                                    <div
                                        class="form-check form-check-inline"
                                        v-if="displayFilters.offers.allProducts"
                                    >
                                        <input
                                            type="checkbox"
                                            v-model="
                                                filters.offerIdsAllProducts
                                            "
                                            v-bind:disabled="
                                                !filters.offerIds.length
                                            "
                                            class="form-check-input"
                                        />
                                        <label class="form-check-label"
                                            >Include products in deals</label
                                        >
                                    </div>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="displayFilters.deals && (!displayFilters.deals.position || displayFilters.deals.position != 'main')"
                                >
                                    <label> Deal </label>
                                    <select
                                        id="dealIds"
                                        name="dealIds"
                                        class="chosen-select filter-id-values form-control form-control-alt"
                                        multiple="multiple"
                                        v-model="filters.dealIds"
                                        data-placeholder="Select Deals"
                                    >
                                        <option
                                            :value="deal.id"
                                            v-for="(deal,oIdx) in displayFilters.deals.data"
                                            :key="oIdx"
                                        >
                                            {{ deal.name }}
                                        </option>
                                    </select>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="
                                        displayFilters.templates &&
                                            (!displayFilters.templates.position ||
                                                displayFilters.templates
                                                    .position != 'main')
                                    "
                                >
                                    <label> Template </label>
                                    <select
                                        id="templatesIds"
                                        name="templatesIds"
                                        class="chosen-select filter-id-values form-control form-control-alt"
                                        multiple="multiple"
                                        v-model="filters.templatesIds"
                                        data-placeholder="Select Templates"
                                    >
                                        <option
                                            :value="template.id"
                                            v-for="(template,
                                            oIdx) in displayFilters.templates.data"
                                            :key="oIdx"
                                        >
                                            {{ template.name }}
                                        </option>
                                    </select>
                                     
                                </div>
                                <span
                                    v-if="displayFilters.statuses2 && (!displayFilters.statuses2.position || displayFilters.statuses2.position != 'main')"
                                    v-show="
                                        !displayFilters.statuses2.dependent || (
                                                displayFilters.statuses2.dependent &&
                                                filters[displayFilters.statuses2.dependent] && (
                                                        !Array.isArray(filters[displayFilters.statuses2.dependent].length) ||
                                                        filters[displayFilters.statuses2.dependent].length
                                                )
                                         )
                                    "
                                >
                                        <div class="item-filter">
                                            <span v-if="displayFilters.statuses2.type === 'multiple'">
                                                <label> {{displayFilters.statuses2.name || 'Statuses'}} </label>
                                                <multiselect
                                                        class="col col-sm-12 col-md-4 col-lg-12 p-0"
                                                        id="statuses2"
                                                        v-model="
                                                        selected_statuses_2
                                                    "
                                                        :options="displayFilters.statuses2.data"
                                                        :multiple="true"
                                                        :close-on-select="false"
                                                        track-by="id"
                                                        label="name"
                                                        :hide-selected="true"
                                                        :placeholder="
                                                        displayFilters.statuses2.name ||
                                                            'Select Status(es)'
                                                    "
                                                        @input="applyData(true)"
                                                ></multiselect>
                                            </span>
                                            <span v-else>
                                                <label> {{displayFilters.statuses2.name || 'Status'}} </label>
                                                <select
                                                        id="status2"
                                                        class="form-control"
                                                        v-model="filters.status2"
                                                        @change="applyData(true)"
                                                >
                                                    <option :value="null"
                                                    >- All
                                                        {{
                                                            displayFilters.statuses2.name ||
                                                                'Statuses'
                                                        }}
                                                        -</option
                                                    >
                                                    <option
                                                            :value="status.id"
                                                            v-for="(status,
                                                        sIdx) in displayFilters.statuses2.data"
                                                            :key="sIdx"
                                                    >{{
                                                            status.name
                                                        }}</option
                                                    >
                                                </select>
                                            </span>
                                        </div>
                                    </span>
                                <div
                                    class="form-group"
                                    v-if="
                                        displayFilters.venues &&
                                            (!displayFilters.venues.position ||
                                                displayFilters.venues
                                                    .position != 'main')
                                    "
                                >
                                    <label> Venue </label>
                                    <select
                                        id="venueId"
                                        class="form-control form-control-alt"
                                        v-model="filters.venueId"
                                    >
                                        <option :value="''"
                                            >--select one--</option
                                        >
                                        <option
                                            :value="venue.id"
                                            v-for="(venue,
                                            vIdx) in displayFilters.venues.data"
                                            :key="vIdx"
                                        >
                                            {{ venue.name }}
                                        </option>
                                    </select>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="
                                        displayFilters.items &&
                                            (!displayFilters.items.position ||
                                                displayFilters.items.position !=
                                                    'main')
                                    "
                                >
                                    <label> Item </label>
                                    <select
                                        id="filter-items"
                                        class="chosen-select filter-items form-control form-control-alt"
                                        multiple="multiple"
                                        data-placeholder="Select Items"
                                    >
                                        <optgroup
                                            :label="group.label"
                                            v-for="(group, gIdx) in printItems(
                                                displayFilters.items
                                            )"
                                            :key="gIdx"
                                        >
                                            <option
                                                :value="item.value"
                                                :selected="item.selected"
                                                v-for="(item,
                                                iIdx) in group.items"
                                                :key="iIdx"
                                                >{{ item.name }}
                                            </option>
                                        </optgroup>
                                    </select>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="displayFilters.fields"
                                >
                                    <label>Field</label>
                                    <select
                                        id="filter-fields"
                                        class="chosen-select filter-fields form-control-alt"
                                        multiple="multiple"
                                    >
                                        <optgroup
                                            :label="group.label"
                                            v-for="(group, gIdx) in printFields(
                                                displayFilters.fields
                                            )"
                                            :key="gIdx"
                                        >
                                            <option
                                                :value="field.value"
                                                :selected="field.selected"
                                                v-for="(field,
                                                fIdx) in group.fields"
                                                :key="fIdx"
                                                >{{ field.name }}
                                            </option>
                                        </optgroup>
                                    </select>
                                </div>

                                <div
                                    class="filter-group"
                                    v-if="
                                        displayFilters.groupFilters &&
                                            filters.group
                                    "
                                >
                                    <div class="form-group mb-1">
                                        <label>Filter Grouping</label>
                                    </div>
                                    <div class="form-group">
                                        <label>Group Logic</label>
                                        <select
                                            class="form-control form-control-alt"
                                            v-model="filters.group.logic"
                                        >
                                            <option value="AND"
                                                >All are True</option
                                            >
                                            <option value="OR"
                                                >One is True</option
                                            >
                                        </select>
                                    </div>
                                    <div
                                        class="filter-group-inner mr-3 ml-3 mb-2"
                                        v-for="(grouping, i) in filters.group
                                            .groupings"
                                        v-if="
                                            filters.group.groupings &&
                                                filters.group.groupings.length
                                        "
                                        :key="i"
                                    >
                                        <div class="form-group mb-1">
                                            <div class="d-flex flex-fill">
                                                <div class="flex-grow-1">
                                                    <label>{{
                                                        displayFilters
                                                            .groupFilters
                                                            .groupBy
                                                    }}</label>
                                                </div>
                                                <div v-if="grouping.itemId">
                                                    <button
                                                        class="btn btn-sm btn-danger p-1"
                                                        title="Remove Filter Grouping"
                                                        data-toggle="tooltip"
                                                        @click="
                                                            removeGrouping(i)
                                                        "
                                                    >
                                                        <i
                                                            class="fa fa-times"
                                                        ></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <span
                                                v-if="
                                                    displayFilters.groupFilters
                                                        .groupBy === 'item'
                                                "
                                            >
                                                <select
                                                    class="form-control form-control-alt"
                                                    @change="
                                                        groupFilterChanged(
                                                            $event,
                                                            grouping,
                                                            'item'
                                                        )
                                                    "
                                                >
                                                    <option value=""
                                                        >-Select One-</option
                                                    >
                                                    <optgroup
                                                        :label="group.label"
                                                        v-for="(group,
                                                        gIdx) in printItems(
                                                            displayFilters.groupFilters
                                                        )"
                                                        :key="gIdx"
                                                    >
                                                        <option
                                                            :value="item.value"
                                                            :selected="
                                                                item.selected
                                                            "
                                                            v-for="(item,
                                                            iIdx) in group.items"
                                                            :key="iIdx"
                                                            >{{
                                                                item.name
                                                            }}</option
                                                        >
                                                    </optgroup>
                                                </select>
                                            </span>
                                        </div>
                                        <div
                                            v-for="(filter,
                                            filterType) in displayFilters
                                                .groupFilters.filters"
                                            :key="filterType"
                                        >
                                            <span>
                                                <div
                                                    class="form-group mb-1"
                                                    v-if="
                                                        grouping.itemId &&
                                                            filterType ==
                                                                'field'
                                                    "
                                                    @change="
                                                        groupFilterChanged(
                                                            $event,
                                                            grouping,
                                                            'field'
                                                        )
                                                    "
                                                >
                                                    <label>Field</label>
                                                    <select
                                                        class="form-control form-control-alt"
                                                    >
                                                        <option value=""
                                                            >-Select
                                                            One-</option
                                                        >
                                                        <optgroup
                                                            :label="group.label"
                                                            v-for="(group,
                                                            gIdx) in printFields(
                                                                filter
                                                            )"
                                                            :key="gIdx"
                                                        >
                                                            <option
                                                                :value="
                                                                    field.value
                                                                "
                                                                :selected="
                                                                    field.selected
                                                                "
                                                                v-for="(field,
                                                                fIdx) in group.fields"
                                                                :key="fIdx"
                                                                >{{
                                                                    field.name
                                                                }}</option
                                                            >
                                                        </optgroup>
                                                    </select>
                                                </div>
                                                <div
                                                    class="form-group mb-1"
                                                    v-if="
                                                        grouping.itemId &&
                                                            filterType ==
                                                                'active'
                                                    "
                                                    @change="$forceUpdate()"
                                                >
                                                    <label> Active </label>
                                                    <select
                                                        class="form-control-alt form-control"
                                                        v-model="
                                                            grouping.active
                                                        "
                                                    >
                                                        <option value=""
                                                            >--All--</option
                                                        >
                                                        <option value="unused"
                                                            >Unused</option
                                                        >
                                                        <option value="yes"
                                                            >Yes</option
                                                        >
                                                        <option value="expired"
                                                            >Expired</option
                                                        >
                                                    </select>
                                                </div>
                                                <div
                                                    v-if="
                                                        filterType == 'redeemed'
                                                    "
                                                >
                                                    <div
                                                        v-if="
                                                            grouping.itemId &&
                                                                grouping.active &&
                                                                grouping.active !=
                                                                    'unused'
                                                        "
                                                    >
                                                        <div
                                                            class="form-group mb-1"
                                                            v-if="
                                                                grouping.itemType ==
                                                                    'deal'
                                                            "
                                                        >
                                                            <label
                                                                >Redemptions
                                                                Made</label
                                                            >
                                                            <div class="d-flex">
                                                                <select
                                                                    id="redeemedOperator"
                                                                    class="form-control-alt form-control"
                                                                    v-model="
                                                                        grouping.redeemedOperator
                                                                    "
                                                                >
                                                                    <option
                                                                        value="="
                                                                        >=</option
                                                                    >
                                                                    <option
                                                                        value=">"
                                                                        >></option
                                                                    >
                                                                    <option
                                                                        value=">="
                                                                        >>=</option
                                                                    >
                                                                    <option
                                                                        value="<"
                                                                        ><</option
                                                                    >
                                                                    <option
                                                                        value="<="
                                                                        ><=</option
                                                                    >
                                                                </select>
                                                                <input
                                                                    autocomplete="off"
                                                                    type="number"
                                                                    id="redeemed"
                                                                    class="form-control flex-grow-1 form-control-alt"
                                                                    v-model="
                                                                        grouping.redeemed
                                                                    "
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="form-group mb-1"
                                                            v-else-if="
                                                                grouping.itemType ==
                                                                    'product'
                                                            "
                                                        >
                                                            <label
                                                                >Redemptions
                                                                Made</label
                                                            >
                                                            <div class="d-flex">
                                                                <select
                                                                    id="redeemedOperator"
                                                                    class="form-control-alt form-control"
                                                                    v-model="
                                                                        grouping.redeemed
                                                                    "
                                                                >
                                                                    <option
                                                                        value="yes"
                                                                        >Yes</option
                                                                    >
                                                                    <option
                                                                        value="no"
                                                                        >No</option
                                                                    >
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </span>
                                            <hr
                                                v-if="
                                                    filters.group.groupings &&
                                                        filters.group.groupings
                                                            .length &&
                                                        filters.group.groupings[
                                                            i + 1
                                                        ]
                                                "
                                            />
                                        </div>
                                        <div
                                            v-if="
                                                filters.group.groupings &&
                                                    filters.group.groupings
                                                        .length &&
                                                    filters.group.groupings[
                                                        filters.group.groupings
                                                            .length - 1
                                                    ].itemId
                                            "
                                        >
                                            <button
                                                class="btn btn-light btn-sm"
                                                @click="addGrouping()"
                                            >
                                                Add Filter Group
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="displayFilters.promos"
                                >
                                    <label>Promo Used</label>
                                    <select
                                        id="promoId"
                                        class="form-control-alt form-control"
                                        v-model="filters.promoId"
                                    >
                                        <option :value="null"
                                            >-Select One-</option
                                        >
                                        <option
                                            :value="promo.id"
                                            v-for="(promo,
                                            pIdx) in displayFilters.promos.data"
                                            :key="pIdx"
                                            >{{ promo.name }}
                                        </option>
                                    </select>
                                </div>
								
                                <div
                                    class="form-group"
                                    v-if="displayFilters.redeemed"
                                >
                                    <label>Redemptions Made</label>
                                    <div class="d-flex">
                                        <select
                                            id="redeemedOperator"
                                            class="form-control-alt form-control"
                                            v-model="filters.redeemedOperator"
                                        >
                                            <option value="=">=</option>
                                            <option value=">">></option>
                                            <option value=">=">>=</option>
                                            <option value="<"><</option>
                                            <option value="<="><=</option>
                                        </select>
                                        <input
                                            autocomplete="off"
                                            type="number"
                                            id="redeemed"
                                            class="form-control flex-grow-1 form-control-alt"
                                            v-model="filters.redeemed"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="
                                        displayFilters.categories &&
                                            (!displayFilters.categories
                                                .position ||
                                                displayFilters.categories
                                                    .position != 'main')
                                    "
                                >
                                    <label> Category </label>
                                    <select
                                        id="categoryId"
                                        class="form-control"
                                        v-model="filters.categoryId"
                                        @change="applyData(true)"
                                    >
                                        <option :value="null"
                                            >- All Categories -</option
                                        >
                                        <option
                                            :value="category.id"
                                            v-for="(category,
                                            cIdx) in displayFilters.categories
                                                .data"
                                            :key="cIdx"
                                        >
                                            {{ category.name }}
                                        </option>
                                    </select>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="displayFilters.categoryTypes"
                                >
                                    <label>Type</label>
                                    <select
                                        id="categoryTypeId"
                                        class="form-control-alt form-control"
                                        v-model="filters.type"
                                    >
                                        <option value=""
                                            >--All Category Type--</option
                                        >
                                        <option value="venue">Venue</option>
                                        <option value="item"
                                            >Item (package, deal or
                                            product)</option
                                        >
                                        <option value="perk">Perk</option>
                                    </select>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="
                                        displayFilters.statuses &&
                                            (!displayFilters.statuses
                                                .position ||
                                                displayFilters.statuses
                                                    .position != 'main')
                                    "
                                >
                                    <label> Status </label>
                                    <select
                                        id="status"
                                        class="form-control"
                                        v-model="filters.status"
                                        @change="applyData(true)"
                                    >
                                        <option :value="''"
                                            >- All Statuses -</option
                                        >
                                        <option
                                            :value="status.id"
                                            v-for="(status,
                                            sIdx) in displayFilters.statuses
                                                .data"
                                            :key="sIdx"
                                        >
                                            {{ status.name }}
                                        </option>
                                    </select>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="displayFilters.flagged"
                                >
                                    <label> Flagged </label>
                                    <select
                                        id="flagged"
                                        class="form-control-alt form-control"
                                        v-model="filters.flagged"
                                    >
                                        <option :value="null">--All--</option>
                                        <option value="1">Yes</option>
                                    </select>
                                </div>
                                <div v-if="displayFilters.rescheduled">
                                    <label>Repeating:</label>
                                    <select
                                        id="rescheduled"
                                        class="form-control-alt form-control"
                                        v-model="filters.rescheduled"
                                    >
                                        <option value="">--All--</option>
                                        <option value="1">Yes</option> </select
                                    ><br />
                                </div>
                                <div
                                    class="form-group"
                                    v-if="displayFilters.active"
                                >
                                    <label> Active </label>
                                    <select
                                        id="categoryTypeId"
                                        class="form-control-alt form-control"
                                        v-model="filters.active"
                                    >
                                        <option value="">--All--</option>
                                        <option value="unused">Unused</option>
                                        <option value="yes">Yes</option>
                                        <!--										<option value="no">No</option>-->
                                        <option value="expired">Expired</option>
                                    </select>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="displayFilters.deleted"
                                >
                                    <div class="form-check form-check-inline">
                                        <input
                                            v-model="filters.showDeleted"
                                            class="form-check-input"
                                            type="checkbox"
                                            :value="1"
                                            false-value=""
                                        />
                                        <label class="form-check-label"
                                            >Archived</label
                                        >
                                    </div>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="displayFilters.inactive"
                                >
                                    <div class="form-check form-check-inline">
                                        <input
                                            v-model="filters.showInactive"
                                            class="form-check-input"
                                            type="checkbox"
                                            :value="1"
                                            false-value=""
                                        />
                                        <label class="form-check-label"
                                        >Inactive</label
                                        >
                                    </div>
                                </div>
                                <div
                                    class="form-group"
                                    v-if="displayFilters.mTypes"
                                >
                                    <label>Message Type</label>
                                    <select
                                        class="form-control"
                                        name="selectFilterStatus"
                                        id=""
                                        v-model="filters.sendType"
                                        @change="applyData()"
                                    >
                                        <option :value="null"></option>
                                        <option value="email">Email</option>
                                        <option value="text">Text</option>
                                        <option value="feed">Feed</option>
                                    </select>
                                </div>
                            </div>

                            <div
                                class="block-content block-content-full text-right border-top"
                            >
                                <button
                                    type="button"
                                    class="btn btn-sm btn-light"
                                    data-dismiss="modal"
                                >
                                    Close
                                </button>
                                <button
                                    v-on:click="resetData"
                                    class="btn btn-light btn-sm"
                                >
                                    <i class="si si-reload fa-1x mr-1"></i
                                    ><span>Reset</span>
                                </button>
                                <button
                                    v-on:click="applyData(true)"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    class="btn btn-primary btn-sm"
                                >
                                    Apply
                                </button>
                                <button
                                    data-toggle="modal"
                                    :data-target="'#save-preset'"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    class="btn btn-info btn-sm"
                                    @click="preparePreset()"
                                    v-if="displayFilters.presets"
                                >
                                    {{ filters.preset ? 'Update' : 'Save' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="modal"
                id="save-preset"
                tabindex="-1"
                role="dialog"
                aria-labelledby="save-preset"
                aria-hidden="true"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="block block-themed block-transparent mb-0">
                            <div class="block-header bg-primary-dark">
                                <h3 class="block-title">
                                    <span v-if="reportPreset.id">Update</span
                                    ><span v-else>Save</span>Report
                                </h3>
                                <div class="block-options">
                                    <button
                                        type="button"
                                        class="btn-block-option"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <i class="fa fa-fw fa-times"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="block-content font-size-sm">
                                <div class="form-group">
                                    <label for="saveName" class="control-label"
                                        >Name:</label
                                    >

                                    <div class="controls">
                                        <input
                                            autocomplete="off"
                                            id="name"
                                            name="name"
                                            type="text"
                                            class="form-control form-control-alt"
                                            v-model="reportPreset.name"
                                        />
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Report For</label>
                                    <div class="form-check">
                                        <input
                                            autocomplete="off"
                                            class="form-check-input form-control-alt"
                                            type="radio"
                                            id="report-for1"
                                            name="report-for"
                                            :value="userId"
                                            v-model="reportPreset.user_id"
                                            checked
                                        />
                                        <label
                                            class="form-check-label"
                                            for="report-for1"
                                            >Just me</label
                                        >
                                    </div>
                                    <div class="form-check">
                                        <input
                                            autocomplete="off"
                                            class="form-check-input form-control-alt"
                                            type="radio"
                                            id="report-for"
                                            name="report-for"
                                            :value="0"
                                            v-model="reportPreset.user_id"
                                        />
                                        <label
                                            class="form-check-label"
                                            for="report-for"
                                            >Company</label
                                        >
                                    </div>
                                </div>
                                <p class="text-warning" v-if="reportPreset.id">
                                    Current preset filters will be overwritten
                                    with newly selected filters.
                                </p>
                            </div>
                            <div
                                class="block-content block-content-full text-right border-top"
                            >
                                <button
                                    type="button"
                                    class="btn btn-sm btn-light"
                                    data-dismiss="modal"
                                >
                                    Close
                                </button>
                                <button
                                    class="btn btn-sm btn-success"
                                    @click.prevent.stop="savePreset"
                                >
                                    <span v-if="reportPreset.id">Update</span
                                    ><span v-else>Save</span>
                                </button>
                                <button
                                    class="btn btn-sm btn-danger"
                                    @click.prevent.stop="deletePreset"
                                    v-if="reportPreset.id"
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="exportContainer"></div>
    </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import $api from "@api/api";


export default {
    components: {
        DateRangePicker
    },
    props: {
        displayFilters: {
            type: Object,
            required: true
        },
        filters: {
            type: Object,
            required: true
        },
        partnerId: {
            type: Number,
        },
        url: {
            type: String
        },
        checkedColumns: {
            type: Array
        },
        subReports: {
            type: Array
        },
        searchTerm: {
            type: String | Number
        },
        userId: {
            type: Number
        },
        report: {
            type: Object
        },
        columnOptions: {
            type: Object
        },
        type: {
            type: String
        },
        disableButton: {
            type: Boolean,
            default: false
        },
        showApplyButton: {
            type: Boolean,
            default: false
        },
        buttonColor: {
            type: String,
            default: 'blue-grey'
        },
        buttonText: {
            type: String,
            default: ''
        },
        showSpinnerOnApplyButton: {
            type: Boolean,
            default: false
        },
        waitTimeUntilMail: {
            type: Number,
            default: 15000
        },
        
    },
    data() {
        return {
            columnSelect: false,
            defaultFilters: {},
            activeMenu: true,
            reportPreset: { name: '' },
            success_msg: '',
            error_msg: '',
            lastSearch: '',
            lastSearchType: '',
            filterCount: 0,
            searchTimeout: null,
            chosenDefaults: {
                width: '100%',
                containerCssClass: 'form-control-alt'
            },
            massEditMode: false,
            allStatuses: [],
            dateRangeChange: {},
            picker1: false,
            pickerDate: false,
            pickerMonth: false,
            filterChangedTimeout: null,
            saveDefaults: false,
            dates: [],
            date: null,
            exportLoading: false,
            exportTimeout: null,
            exportResults: null,
			isValid: false,
        }
    },

    computed: {
        rangeOptions() {
            let today = new Date()
            today.setHours(0, 0, 0, 0)

            let tomorrow = new Date()
            tomorrow.setDate(today.getDate() + 1)
            tomorrow.setHours(0, 0, 0, 0)

            let yesterday = new Date()
            yesterday.setDate(today.getDate() - 1)
            yesterday.setHours(0, 0, 0, 0)

            let thisMonthStart = new Date(
                today.getFullYear(),
                today.getMonth(),
                1
            )
            let thisMonthEnd = new Date(
                today.getFullYear(),
                today.getMonth() + 1,
                0
            )
            return {
                Today: [today, tomorrow],
                Yesterday: [yesterday, today],
                'This month': [thisMonthStart, thisMonthEnd],
                'This year': [
                    new Date(today.getFullYear(), 0, 1),
                    new Date(today.getFullYear(), 11, 31)
                ],
                'Last month': [
                    new Date(today.getFullYear(), today.getMonth() - 1, 1),
                    new Date(today.getFullYear(), today.getMonth(), 0)
                ],
                'Last 3 months': [
                    new Date(
                        moment()
                            .subtract(3, 'months')
                            .format('YYYY-MM-DD')
                    ),
                    new Date(moment())
                ]
            }
        },
        computedDateRange: {
            get() {
                if (this.filters.startDateTime === '') {
                    return {
                        startDate: null,
                        endDate: null
                    }
                }

                return {
                    startDate: Bandwango.dateToLocal(
                        this.filters.startDateTime
                    ),
                    endDate: Bandwango.dateToLocal(this.filters.endDateTime)
                }
            },
            set(v) {
                this.filters.startDateTime = Bandwango.dateToUtc(
                    moment(v.startDate)
                        .startOf('day')
                        .format('YYYY-MM-DD h:mm a')
                )
                this.filters.endDateTime = Bandwango.dateToUtc(
                    moment(v.endDate)
                        .endOf('day')
                        .format('YYYY-MM-DD h:mm a')
                )
                this.filters.dateRange = `${moment(v.startDate).format(
                    'MM/DD/YY'
                )} - ${moment(v.endDate).format('MM/DD/YY')}`
            }
        },
        computedDateRange2: {
            // for vueitify
            get() {
                if (!this.dates[0]) {
                    const dates = [ moment(this.filters.startDateTime).format(
                        'YYYY-MM-DD'
                    )];
                    if (this.filters.endDateTime)
                        dates[1] = moment(this.filters.endDateTime)
                            .subtract(1, 'days')
                            .format('YYYY-MM-DD')
                    return dates;
                }
                return this.dates
            },
            set(v) {
                const dates = [
                    ...v.sort((a, b) => {
                        return moment(a).isBefore(moment(b)) ? -1 : 1
                    })
                ]
                // the dates array is what is being sent back to the date picker (which doesn't handle time formatting well).
                // Therefore we just need to send the date
                this.dates = dates.map(x => moment(x).format('YYYY-MM-DD'))
                this.filters.dateRange = dates
                    .map(x => moment(x).format('MM/DD/YY'))
                    .join(' - ')
                if (dates.length === 2) {
                    // the filters need the time format included therefore we add it here
                    this.filters.startDateTime = moment(dates[0])
                        .startOf('day')
                        .format('YYYY-MM-DDTHH:mm:ss')
                    // secretly pass midnight of the next day since our queries use "<" comparisons instead of <=
                    this.filters.endDateTime = moment(dates[1])
                        .add(1, 'days')
                        .startOf('day')
                        .format('YYYY-MM-DDTHH:mm:ss')
                }
            }
        },
        computedDate: {
            get() {
				const dateFilter = this.compFilters.find(f => f.key === 'date');
				const offset = dateFilter?.offset ?? 0
				return moment(this.filters.date).subtract(1 - offset, 'day').format('YYYY-MM-DD');
			},
			 
            set(v) {
				const dateFilter = this.compFilters.find(f => f.key === 'date');
				const offset = dateFilter?.offset ?? 0
                this.filters.date = moment(v).add(1 - offset, 'day').format('YYYY-MM-DDTHH:mm:ss');
            }
        },
        computedMonth: {
            get() {
                return moment(this.filters.month).format('YYYY-MM');
            },
            set(v) {
                this.filters.month = moment(v).format('YYYY-MM-DDTHH:mm:ss');
            }
        },
        computedDisplayDate: function() {
            return moment(this.computedDate).format('MM/DD/YY');
        },
        computedDisplayMonth: function() {
            return moment(this.computedMonth).format('MM/YY');
        },
        selected_statuses: {
            get() {
                if (!this.filters.statuses) return []

                let statuses = [...this.allStatuses]
                if (this.displayFilters.statuses)
                    statuses = [...this.displayFilters.statuses.data]

                return statuses.filter(status => {
                    return (
                        this.filters.statuses.map(Number).indexOf(status.id) >
                        -1
                    )
                })
            },
            set(newVal) {
                this.filters.statuses = newVal.map(v => v.id)
            }
        },
        selected_statuses_2: {
            get() {
                if (!this.filters.statuses2) return []

                let statuses = [...this.allStatuses]
                if (this.displayFilters.statuses2)
                    statuses = [...this.displayFilters.statuses2.data]

                return statuses.filter(status => {
                    return (
                        this.filters.statuses2.map(Number).indexOf(status.id) >
                        -1
                    )
                })
            },
            set(newVal) {
                this.filters.statuses2 = newVal.map(v => v.id)
            }
        },
        selected_items: {
            get() {
                const items = []
                if (this.filters.packageIds) {
                    this.filters.packageIds.forEach(pkId => {
                        items.push('k-' + pkId)
                    })
                }
                if (this.filters.dealIds) {
                    this.filters.dealIds.forEach(dId => {
                        items.push('d-' + dId)
                    })
                }
                if (this.filters.productIds) {
                    this.filters.productIds.forEach(pId => {
                        items.push('p-' + pId)
                    })
                }
                return items
            },
            set(items) {
                if (items) {
                    this.filters.packageIds = []
                    this.filters.dealIds = []
                    this.filters.productIds = []

                    for (var i = 0; i < items.length; i++) {
                        let itemSplit = items[i].split('-')

                        if (itemSplit[0] == 'k') {
                            this.filters.packageIds.push(Number(itemSplit[1]))
                        } else if (itemSplit[0] == 'd') {
                            this.filters.dealIds.push(Number(itemSplit[1]))
                        } else if (itemSplit[0] == 'p') {
                            this.filters.productIds.push(Number(itemSplit[1]))
                        }
                    }
                }
                // this.applyData()
            }
        },
        compFilters: {
            get() {
                let displayFilters = []
                Object.keys(this.displayFilters).forEach(key => {
                    if (this.displayFilters[key].position === 'main') {
                        this.displayFilters[key].key = key
                        displayFilters.push(this.displayFilters[key])
                    }
                })
                displayFilters = displayFilters.sort((a, b) => a.sort - b.sort)
                return displayFilters
            }
        },
        hasMoreFilters: {
            get() {
                let more = false
                Object.keys(this.displayFilters).forEach(key => {
                    if (this.displayFilters[key].position !== 'main') {
                        more = true
                    }
                })
                return more
            }
        },
        hasFilterValue: {
            get() {
                let has = false
                Object.keys(this.filters).forEach(key => {
                    if (
                        (['deleted', 'display', 'page', 'report'].indexOf(
                            key
                        ) === -1 &&
                            this.filters[key] != null &&
                            this.filters[key] != undefined &&
                            this.filters[key] != '') ||
                        (typeof this.filters[key] == 'array' &&
                            this.filters[key].length) ||
                        (key === 'group' &&
                            this.filters[key] &&
                            this.filters[key].groupings?.length &&
                            !isEmpty(this.filters[key].groupings[0]))
                    ) {
                        has = true
                    }
                })
                return has
            }
        },
        showPromoOnSalesChannel() {
          if (this.displayFilters.salesChannels) {
              return this.filters.salesChannel && this.filters.salesChannel === 'promo_revenue';
          } else {
            return true;
          }
        },
        showResellerOnSalesChannel() {
          if (this.displayFilters.salesChannels) {
              return this.filters.salesChannel && this.filters.salesChannel === 'reseller_revenue';
          } else {
            return true;
          }
        }
    },

    methods: {
        reportChanged: function() {
            this.saveDefaults = true
            this.applyData(true)
        },
        getData: function() {
            this.$emit('get-data', this.getFilters())
            this.$emit('search-data', this.lastSearch, this.lastSearchType)
        },

        applyData: function(shouldReset = false) {
            //Reset the offerIdsAllProducts checkbox if no offer is selected
            if (!this.filters.offerIds && this.filters.offerIdsAllProducts) {
                this.filters.offerIdsAllProducts = false
            }
            if (shouldReset) {
                // reset page
                this.filters.page = 1
                this.$emit('reset-page', 1)
            }
            this.getData()
            this.updateFilterCount()
            this.cookieFilters()
        },

        fixClearBtn() {
            setTimeout(() => {
                $('#searchClear').css({
                    right: $('#searchButton').width() + 30 + 'px'
                })
            }, 50)
        },

        clearSearchText() {
            this.filters.search = ''
            this.lastSearch = ''
            this.lastSearchType = ''
            this.applyData(true)
            alert('reset')
        },

        updateSearchParams: function() {
            const params = {
                search: this.filters.search ? this.filters.search : null,
                type: this.filters.searchType ? this.filters.searchType : null,
                page: null // New search will always return page 1
            }
            const newUrl = new URL(window.location.href)
            for (const [key, val] of Object.entries(params)) {
                val === null
                    ? newUrl.searchParams.delete(key)
                    : newUrl.searchParams.set(key, val)
            }
            newUrl.searchParams.sort()
            window.history.pushState('', '', newUrl.toString())
        },

        searchChanged: function(type = false, manual = false) {
            if (!this.displayFilters.searchOptions) return
            if (type) {
                let i = _.invert(this.displayFilters.searchOptions.data)[type]
                if (i) this.filters.searchType = i
            }

            if (!this.filters.search) this.filters.search = ''
            const searchOptionValues = Object.keys(
                this.displayFilters.searchOptions.data
            )

            if (!manual) {
                // guess what they are searching
                if (/^[^\s@]+@[^\s@]+$/.test(this.filters.search)) {
                    const f = searchOptionValues.find(
                        x => x.toLowerCase().indexOf('email') > -1
                    )
                    if (f) this.filters.searchType = f
                } else if (/^\d+$/.test(this.filters.search)) {
                    if (this.filters.search.length > 8) {
                        const f = searchOptionValues.find(
                            x => x.toLowerCase().indexOf('phone') > -1
                        )
                        if (f && this.filters.searchType !== 'giftedPhone')
                            this.filters.searchType = f
                    } else {
                        const f = searchOptionValues.find(
                            x => x.toLowerCase().indexOf('id') > -1
                        )
                        if (f) this.filters.searchType = f
                    }
                } else {
                    const f = searchOptionValues.find(
                        x => x.toLowerCase().indexOf('name') > -1
                    )
                    if (f && this.filters.searchType !== 'giftedName')
                        this.filters.searchType = f
                }
            }

            this.lastSearch = this.filters.search
            this.lastSearchType = this.filters.searchType

            //this.setSearch();
            this.updateSearchParams()
            this.applyData(true)

            this.filters.search = ''
        },
        salesChannelsChanged: function() {
          this.filters.resellerIds = null;
          this.filters.promoIds = null;
        },
        salesChannelsData: function () {
          //TODO delete this function when all the reports are migrated to use the reportHelper.js
          return [
            {id: 'sale', name: 'Direct Sale'},
            {id: 'reseller_revenue', name: 'Third Party'},
            {id: 'promo_revenue', name: 'Promotion'},
          ];
        },
        updateFilterCount: function() {
            this.filterCount = 0
            let ignoreKeys = [
                'page',
                'display',
                'search',
                'searchType',
                'redeemedOperator',
                'filter-date-property',
                'chartio',
                'partner_id',
                'dateProperty'
            ]

            for (var key in this.filters) {
                if (key == 'group') {
                    if (!this.filters.group)
                        this.filters.group = { logic: 'AND', groupings: [{}] }
                    this.filters.group.groupings.forEach(grouping => {
                        for (var k in grouping) {
                            if (ignoreKeys.indexOf(key) == -1)
                                this.filterCount++
                        }
                    })
                } else if (
                    ignoreKeys.indexOf(key) == -1 &&
                    (!Array.isArray(this.filters[key]) ||
                        this.filters[key].length) &&
                    this.filters[key]
                ) {
                    this.filterCount++
                }
            }
        },

        resetData: function() {
            const dontReset = [
                'chartio',
                'report',
                'startDateTime',
                'endDateTime'
            ]
            Object.keys(this.filters).forEach(key => {
                if (key === 'searchType') {
                    this.filters[key] = $('#filter-search-type a:first').data(
                        'option-value'
                    )
                } else if (key === 'dateProperty') {
                    this.filters[key] = $(
                        '#filter-date-property option:first'
                    ).val()
                } else if (dontReset.indexOf(key) === -1) {
                    if (Array.isArray(this.filters[key])) {
                        this.filters[key] = []
                    } else {
                        this.filters[key] = null
                    }
                }
            })

            if (!this.filters.display) {
                this.filters.display = 20
            }
            if (!this.filters.redeemedOperator) {
                this.filters.redeemedOperator = '='
            }

            delete this.filters.redeemed

            this.filters.group = { logic: 'AND', groupings: [{}] }

            // this.filters = {...this.filters, ...JSON.parse(JSON.stringify(this.defaultFilters))};
            this.filters = Object.assign(
                this.filters,
                JSON.parse(JSON.stringify(this.defaultFilters))
            )

            this.$emit('reset-page', 1)

            this.lastSearch = ''
            this.lastSearchType = this.filters.searchType
            this.filters.search = ''
            this.filters.searchType = ''
            // if( this.displayFilters.searchOptions )
            // 	this.filters.searchType = this.displayFilters.searchOptions.data[0];

            $('.filters-reset').each(function() {
                $(this).val('')
            })

            $('.chosen-select').each(function() {
                $(this).val('')
            })

            $('.chosen-select').trigger('chosen:updated')
            $('.chosen-select').select2(this.chosenDefaults)

            // $('html, body').animate({
            //	 scrollTop: $("#search").offset().top
            // }, 500);
            this.updateSearchParams()
            this.getData()
            this.updateFilterCount()
            this.cookieFilters()
        },

        cookieFilters: function() {
            var filters = this.getFilters()

            // Need cookie for filters. Name should be TYPE-filters.
            var date = new Date()
            date.setHours(23, 59, 59, 999)
            var expires = 'expires=' + date.toGMTString()
            document.cookie =
                'filters-' +
                this.type +
                JSON.stringify(filters) +
                '; ' +
                expires
        },
        exportData: async function () {
            this.exportLoading = true;
            if (this.waitTimeUntilMail) {
                this.exportTimeout = setTimeout(() => {
                    this.exportLoading = false;
                    const results = this.exportResults;
                    if (results) {
                        results.publicTrackingId = null;
                        if (results.exportId) {
                            $api.reports.setExportByMail(results.exportId);
                        }
                    }
                    One.helpers('notify', {
                        align: 'center',
                        type: 'info',
                        icon: 'fa fa-info mr-1',
                        message: 'The report will be sent to your email shortly.',
                        timer: 10000
                    });
                }, this.waitTimeUntilMail);
            }
            const reportId = this.report.id ?? 'no-name';
            this.exportResults = (await $api.reports.exportReport(reportId, this.getFilters())).data;
        },

        preparePreset: function() {
            const f = this.subReports.find(x => x.id == this.filters.preset)
            if (f) this.reportPreset = f
        },

        savePreset: function() {
            let filters = this.getFilters()

            this.reportPreset.filters = filters
            delete this.reportPreset.filters.preset
            delete this.reportPreset.filters.display
            delete this.reportPreset.filters.page

            if (!this.reportPreset.name) {
                alert('Please fill in a valid report name.')
                return false
            }
            if (!this.reportPreset.parent_id) {
                alert('Something went wrong with creating this report.')
                return false
            }

            // clear nulls
            Object.keys(this.reportPreset.filters).forEach(key => {
                if (!this.reportPreset.filters[key])
                    delete this.reportPreset.filters[key]
            })

            if (this.reportPreset.id) {
                axios
                    .put(`/reports/${this.reportPreset.id}`, this.reportPreset)
                    .then(response => {
                        this.reportPreset = response.data

                        let i = this.subReports.findIndex(
                            x => x.id == this.reportPreset.id
                        )
                        if (i > -1) this.subReports[i] = this.reportPreset

                        this.filters.preset = this.reportPreset.id
                        $('#save-preset').modal('hide')
                        this.presetChanged()
                        this.success_msg = 'Report updated successfully.'
                    })
                    .catch(error => {
                        this.error_msg = error
                    })
            } else {
                this.reportPreset.partner_id = this.partnerId
                axios
                    .post(`/reports`, this.reportPreset)
                    .then(response => {
                        this.reportPreset = response.data
                        this.subReports.push(response.data)
                        this.filters.preset = response.data.id
                        $('#save-preset').modal('hide')
                        this.success_msg = 'Report created successfully.'
                    })
                    .catch(error => {
                        this.error_msg = error
                    })
            }
        },

        deletePreset: function() {
            axios
                .delete(`/reports/${this.reportPreset.id}`)
                .then(response => {
                    let i = this.subReports.findIndex(
                        x => x.id == this.reportPreset.id
                    )
                    if (i > -1) this.subReports.splice(i, 1)

                    this.filters.preset = null
                    $('#save-preset').modal('hide')
                    this.success_msg = 'Report removed successfully.'
                })
                .catch(error => {
                    this.error_msg = error
                })
        },

        getStatuses: function() {
            axios
                .get(`/status`)
                .then(response => {
                    this.allStatuses = response.data
                })
                .catch(error => {
                    this.error_msg = error.response.data.message
                })
        },

        getFilters: function() {
            let filters = JSON.parse(JSON.stringify(this.filters))
            // if(filters.dateRange != '') this.filters.dateRange = filters.dateRange

            // let allFields = (filters.fields && filters.fields.data) || [];
            let allFields =
                (this.displayFilters.fields &&
                    this.displayFilters.fields.data) ||
                []

            let items = $('.filter-items').val()
            if (items) {
                this.filters.packageIds = filters.packageIds = []
                this.filters.dealIds = filters.dealIds = []
                this.filters.productIds = filters.productIds = []

                for (var i = 0; i < items.length; i++) {
                    let itemSplit = items[i].split('-')

                    if (itemSplit[0] == 'k') {
                        this.filters.packageIds.push(Number(itemSplit[1]))
                        filters.packageIds.push(Number(itemSplit[1]))
                    } else if (itemSplit[0] == 'd') {
                        this.filters.dealIds.push(Number(itemSplit[1]))
                        filters.dealIds.push(Number(itemSplit[1]))
                    } else if (itemSplit[0] == 'p') {
                        this.filters.productIds.push(Number(itemSplit[1]))
                        filters.productIds.push(Number(itemSplit[1]))
                    }
                }
            }

            var fields = $('.filter-fields').val()
            if (fields) {
                filters.fields = []
                for (var i = 0; i < fields.length; i++) {
                    let itemSplit = fields[i].split('-')

                    let f = allFields.find(function(x) {
                        if (x.id == itemSplit[1]) return x
                    })
                    if (f) {
                        filters.fields.push({
                            field_id: f.id,
                            value: f.values[itemSplit[2]]
                        })
                    }
                }
            }

            $('.filter-id-values').each(function() {
                if ($(this).val()) {
                    filters[this.id] = $(this).val()
                } else {
                    delete filters[this.id]
                }
            })

            filters.preset = filters.preset ? filters.preset : null

            // check if groupings are invalid
            if (filters.group) {
                if (
                    !filters.group.groupings ||
                    !filters.group.groupings.length ||
                    !filters.group.groupings[0].itemId
                )
                    delete filters.group
            }

            // remember search if they applied other filters
            if (!filters.search && this.lastSearch)
                filters.search = this.lastSearch

            if (!filters.searchType && this.lastSearchType)
                filters.searchType = this.lastSearchType

            // this.$forceUpdate()
            return filters
        },

        printRole: function(role) {
            let name = role.name
            for (let i = 0; i < role.level; i++) {
                name = '-' + name
            }
            return name
        },

        printItems: function(itemFilter) {
            const groups = []
            if (itemFilter.packages) {
                const group = { label: 'Packages', items: [] }
                itemFilter.packages.forEach(pack => {
                    let selected = false
                    if (
                        this.filters.packageIds &&
                        this.filters.packageIds.indexOf(pack.id) > -1
                    )
                        selected = true

                    group.items.push({
                        value: 'k-' + pack.id,
                        name: pack.name,
                        selected
                    })
                })
                groups.push(group)
            }

            if (itemFilter.deals) {
                const group = { label: 'Deals', items: [] }
                itemFilter.deals.forEach(deal => {
                    let selected = false
                    if (
                        this.filters.dealIds &&
                        this.filters.dealIds.indexOf(deal.id) > -1
                    )
                        selected = true

                    group.items.push({
                        value: 'd-' + deal.id,
                        name: deal.name,
                        selected
                    })
                })
                groups.push(group)
            }

            if (itemFilter.products) {
                const group = { label: 'Products', items: [] }
                itemFilter.products.forEach(product => {
                    let selected = false
                    if (
                        this.filters.productIds &&
                        this.filters.productIds.indexOf(product.id) > -1
                    )
                        selected = true

                    group.items.push({
                        value: 'p-' + product.id,
                        name: product.name,
                        selected
                    })
                })
                groups.push(group)
            }

            return groups
        },

        printItemsVuetify: function(itemFilter) {
            const items = []
            if (itemFilter.packages && itemFilter.packages.length) {
                items.push({ header: 'Packages' })
                itemFilter.packages.forEach(pack => {
                    items.push({
                        value: 'k-' + pack.id,
                        name: pack.name,
                        group: 'Packages'
                    })
                })
            }

            if (itemFilter.deals && itemFilter.deals.length) {
                items.push({ header: 'Deals' })
                itemFilter.deals.forEach(deal => {
                    items.push({
                        value: 'd-' + deal.id,
                        name: deal.name,
                        group: 'Deals'
                    })
                })
            }

            if (itemFilter.products && itemFilter.products.length) {
                items.push({ header: 'Products' })
                itemFilter.products.forEach(product => {
                    items.push({
                        value: 'p-' + product.id,
                        name: product.name,
                        group: 'Products'
                    })
                })
            }
            return items
        },

        printFields: function(fieldFilter) {
            const groups = []
            if (fieldFilter && fieldFilter.data) {
                fieldFilter.data.forEach(field => {
                    const group = { label: field.name, fields: [] }
                    field.values.forEach((fv, i) => {
                        let selected = false
                        if (
                            this.filters.fieldId &&
                            field.id === this.filters.fieldId &&
                            this.filters.fieldValue &&
                            fv === this.filters.fieldValue
                        )
                            selected = true

                        group.fields.push({
                            value: 'f-' + field.id + '-' + i,
                            name: fv,
                            selected
                        })
                    })
                    groups.push(group)
                })
            }
            return groups
        },

        columnChecked: function() {
            var self = this

            let newCheckedColumns = []

            $('.filter-columns').each(function() {
                if ($(this).is(':checked')) {
                    newCheckedColumns.push($(this).val())
                    self.$emit('columns-changed', newCheckedColumns)
                }
            })
        },

        presetChanged: function() {
            const vm = this

            let filters = this.getFilters()
            let subReport = this.subReports.find(
                x => x.id == this.filters.preset
            )
            let allFields = (filters.fields && filters.fields.data) || {}

            if (subReport) {
                let subFilters = subReport.filters

                if (typeof subFilters == 'string')
                    subFilters = JSON.parse(subFilters)

                let items = []
                let fields = []
                for (var key in subFilters) {
                    if (subFilters[key]) {
                        if (key == 'packageIds') {
                            items = [
                                ...items,
                                subFilters[key].map(x => 'k-' + x)
                            ]
                        } else if (key == 'dealIds') {
                            items = [
                                ...items,
                                subFilters[key].map(x => 'd-' + x)
                            ]
                        } else if (key == 'productIds') {
                            items = [
                                ...items,
                                subFilters[key].map(x => 'p-' + x)
                            ]
                        } else if (key == 'fields') {
                            subFilters[key].forEach(field => {
                                let i = -1
                                let f = allFields.find(
                                    x => x.id == field.field_id
                                )
                                if (f)
                                    i = f.values.findIndex(
                                        x => x == field.value
                                    )
                                if (i > -1)
                                    fields.push('f-' + field.field_id + '-' + i)
                            })
                        } else {
                            this.filters[key] = subFilters[key]
                        }
                    }
                }

                if (
                    !subFilters['group'] ||
                    !subFilters['group'].groupings ||
                    !subFilters['group'].groupings.length ||
                    !subFilters['group'].groupings[
                        subFilters['group'].groupings.length - 1
                    ].itemId
                )
                    this.filters['group'] = { logic: 'AND', groupings: [{}] }

                $('.filter-items').val(items)
                $('.filter-fields').val(fields)

                setTimeout(x => {
                    $('.chosen-select').trigger('chosen:updated')
                    $('.chosen-select').select2(vm.chosenDefaults)
                }, 250)
            }
        },

        groupFilterChanged: function(ev, grouping, filter) {
            let allFields =
                (this.displayFilters.groupFilters &&
                    this.displayFilters.groupFilters.filters &&
                    this.displayFilters.groupFilters.filters['field'] &&
                    this.displayFilters.groupFilters.filters['field'].data) ||
                []

            let value = ev.target.value
            if (value) {
                const val = value.split('-')
                if (filter === 'item') {
                    grouping.itemId = val[1]
                    if (val[0] === 'k') grouping.itemType = 'package'
                    else if (val[0] === 'd') grouping.itemType = 'deal'
                    else if (val[0] === 'p') grouping.itemType = 'product'
                } else if (filter === 'field') {
                    let f = allFields.find(function(x) {
                        if (x.id === val[1]) return x
                    })
                    if (f)
                        grouping.field = {
                            field_id: f.id,
                            value: f.values[val[2]]
                        }
                }
            } else {
                // reset the select
                if (filter === 'item') {
                    delete grouping.itemType
                    delete grouping.itemId
                } else if (filter === 'field') {
                    delete grouping.field
                }
            }
            // this.$forceUpdate()
        },
        addGrouping() {
            this.filters.group.groupings.push({})
            // this.$forceUpdate()
        },
        removeGrouping(i) {
            this.filters.group.groupings.splice(i, 1)
            if (!this.filters.group.groupings.length)
                this.filters.group.groupings = [{}]

            // this.$forceUpdate()
        },
        updateFilters(toUpdate) {
            this.filters = Object.assign({}, this.filters, toUpdate)
            this.applyData(true)
        },
        setLastSearch(lastSearch, lastSearchType) {
            this.filters.search = lastSearch
            this.filters.searchType = lastSearchType
        },
        massEdit(isEditing) {
            this.massEditMode = isEditing
            if (isEditing) {
                this.updateFilters({ display: 1000 })
            } else {
                this.updateFilters({ display: 20 })
            }
        },
		async applySearch() {
			this.$refs['filtersForm'].validate();
			this.$emit('apply-button');
		}
    },

    beforeMount() {
        const urlParams = new URLSearchParams(window.location.search)
        // initialize data
        this.$set(this.reportPreset, 'user_id', this.userId ? this.userId : 0)
        this.$set(
            this.reportPreset,
            'parent_id',
            (this.report && this.report.id) || 0
        )
        if (
            !Object.prototype.hasOwnProperty.call(this.filters, 'startDateTime')
        )
            this.$set(this.filters, 'startDateTime', '')
        if (!Object.prototype.hasOwnProperty.call(this.filters, 'endDateTime'))
            this.$set(this.filters, 'endDateTime', '')
        // set up default filters
        this.lastSearch = urlParams.get('search') || ''
        this.lastSearchType = urlParams.get('type') || this.displayFilters?.defaultSearchType || ''
        if (this.lastSearch) this.filters.search = this.lastSearch
        if (this.lastSearchType) this.filters.searchType = this.lastSearchType
        if (!this.filters.invitedToCampaignId)
            this.filters.invitedToCampaignId = null
        if (!this.filters.venueId) this.filters.venueId = null
        if (!this.filters.templateId) this.filters.templateId = null
        if (!this.filters.categoryId) this.filters.categoryId = null
        if (!this.filters.promoId) this.filters.promoId = null
        if (!this.filters.flagged) this.filters.flagged = null
        if (!this.filters.status) this.filters.status = null
        if (!this.filters.status2) this.filters.status2 = null
        if (!this.filters.preset) this.filters.preset = null
        if (
            !this.filters.display ||
            (this.filters.display === 1000 && !this.massEditMode)
        )
            this.filters.display = 20
        if (!this.filters.deleted) this.filters.deleted = 0
        if (!this.filters.offerIds) this.$set(this.filters, 'offerIds', [])
        if (!this.filters.offerIdsAllProducts)
            this.$set(this.filters, 'offerIdsAllProducts', false)
        if (!this.filters.dealIds) this.$set(this.filters, 'dealIds', [])
        if (!this.filters.templatesIds) this.$set(this.filters, 'templatesIds', [])
        if (!this.filters.statuses) this.$set(this.filters, 'statuses', [])
        if (!this.filters.statuses2) this.$set(this.filters, 'statuses2', [])
    },

    mounted() {
        const self = this

        this.getStatuses()

        this.defaultFilters = JSON.parse(JSON.stringify(this.filters)) // remember the initial values passed into the component for reset
        if (this.displayFilters.report) this.saveDefaults = true

        document.onreadystatechange = () => {
            if (document.readyState == 'complete') {
                setTimeout(() => {
                    // setup defaults
                    this.filters.group = {
                        ...{
                            logic: 'AND',
                            groupings: [{}]
                        },
                        ...this.filters.group
                    }

                    this.updateFilterCount()
                    this.getData()

                    $('.chosen-select').select2(self.chosenDefaults)
                    // jquery chosen select not playing nicely with vue
                    $('.chosen-select').on('change', ev => {
                        let val = ev.target.value
                        let prop = ev.target.name
                        if (
                            ev.target.selectedOptions &&
                            ev.target.selectedOptions.length
                        )
                            val = Array.from(ev.target.selectedOptions).map(
                                x => x.value
                            )

                        if (prop) this.filters[prop] = val
                    })
                }, 1000)
            }

            // DateRange Stuff default to 'last year' for redemptions -- this is pretty hacky
            if (location.pathname.includes('/reports/redemptions')) {
                let sdt = moment
                    .tz(Bandwango.getTimeZone())
                    .subtract(1, 'year')
                    .format('MM/DD/YYYY')
                self.filters.startDateTime = Bandwango.dateToUtc(
                    moment(sdt).subtract(12, 'month')
                )
                self.filters.endDateTime = Bandwango.dateToUtc(moment())
                self.filters.dateRange =
                    moment(self.filters.startDateTime).format('MM/DD/YYYY') +
                    ' - ' +
                    moment(self.filters.endDateTime).format('MM/DD/YYYY')
            }
        }
        Echo.channel('report-export-event').listen('ReportExported', (ev) => {
                if (ev.trackingId && this.exportResults?.publicTrackingId === ev.trackingId) {

                    if (this.exportTimeout) {
                        clearTimeout(this.exportTimeout);
                    }

                    switch (ev.results.status) {
                        case 'exported': {
                            const reportUrl = ev.reportUrl.replaceAll('{trackingId}', this.exportResults.privateTrackingId);
                            let csvLink = document.createElement('a');
                            csvLink.setAttribute('href', reportUrl);
                            csvLink.setAttribute('download', 'Report Export');
                            csvLink.setAttribute('target', '_blank');
                            document.getElementById('exportContainer').appendChild(csvLink); // required for firefox
                            csvLink.click();
                            One.helpers("notify", {
                                align: "center",
                                type: "info",
                                icon: "fa fa-info mr-1",
                                message: "Click <a href='" + reportUrl + "' target='_blank'>HERE</a> if the file did not auto download.",
                                timer: 10000
                            });
                            break;
                        }
                        case 'mailed': {
                            One.helpers('notify', {
                                align: 'center',
                                type: 'info',
                                icon: 'fa fa-info mr-1',
                                message: 'The report was sent to your mail.',
                                timer: 10000
                            });
                            break;
                        }
                        case 'error': {
                            One.helpers("notify", {
                                align: "center",
                                type: 'danger',
                                icon: 'fa fa-exclamation mr-1',
                                message: ev.results.msg ? ev.results.msg : 'An error occurred while exporting the report.',
                                timer: 10000
                            });
                            break;
                        }
                    }
                    this.exportLoading = false;
                }
            }
        );
    },
    updated: function() {
        const vm = this
        this.$nextTick(function() {
            $('.chosen-select').select2({
                width: '100%',
                containerCssClass: 'form-control-alt'
            })

            if ($(window).width() < 1024) {
                $('body').addClass('mobile-view sb-l-m')
                this.activeMenu = false
            } else {
                $('body').removeClass('mobile-view sb-l-m')
            }
        })
    },
    watch: {
        filters: {
            deep: true,
            handler(filters) {
                if (!this.filters.dateRange && this.filters.startDateTime)
                    this.filters.dateRange =
                        moment(this.filters.startDateTime).format('MM/DD/YY') +
                        ' - ' +
                        moment(this.filters.endDateTime)
                            .format('MM/DD/YY') // We don't need to subtract a day here, because this is the initial load value

                clearTimeout(this.filterChangedTimeout)
                this.filterChangedTimeout = setTimeout(() => {
                    // if report changed we want to set the defaultfilters
                    if (this.saveDefaults) {
                        this.saveDefaults = false
                        this.defaultFilters = JSON.parse(
                            JSON.stringify(filters)
                        )
                    }
                }, 500)

                this.$forceUpdate()
				this.$emit('filter-changed', filters)
            }
        },
        displayFilters: {
            deep: true,
            handler() {
                Object.keys(this._computedWatchers).forEach(key => {
                    this._computedWatchers[key].run()
                })
                this.$forceUpdate()
            }
        },
        success_msg: function(msg) {
            if (msg) {
                Bandwango.helpers('notify', {
                    align: 'center',
                    type: 'success',
                    icon: 'fa fa-check mr-1',
                    message: msg
                })
                this.success_msg = ''
            }
        },
        error_msg: function(msg) {
            if (msg) {
                Bandwango.helpers('notify', {
                    align: 'center',
                    type: 'danger',
                    icon: 'fa fa-exclamation mr-1',
                    message: msg
                })
                this.error_msg = ''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
[v-cloak] > * {
    display: none;
}

[v-cloak]::before {
    content: 'loading…';
}

.filterButton {
    transition: all 0.25s ease-in-out;
}

.header-menu-content-container {
    display: flex;
    flex-direction: column;
}

.daterangepicker_start_input,
.daterangepicker_end_input {
    display: none !important;
}

.set-width,
.select2,
.select2-container,
.select2-selection,
.select2-selection--multiple {
    width: 275px !important;
}
/*
.item-filter {
    min-width: 250px;
    max-width: 325px;
    margin-right: 8px;
} */
/* .nav-main-horizontal {
  height: 75px !important;
} */
</style>
